import { createClient } from '@supabase/supabase-js';

/**
 * Supabase client.
 *
 * URL + anon key come from environment. Both are public-safe (anon key
 * is rate-limited + RLS-scoped on the server) but still kept out of
 * the bundle via Vite's import.meta.env so a leaked screenshot of
 * network traffic doesn't accidentally expose them in a way that's
 * hard to rotate.
 *
 * v1.0-A wires email magic-link + Apple Sign-In. Stripe / RevenueCat
 * are day-3 / v1.0-D.
 */
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL ?? '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? '';

if (!supabaseUrl || !supabaseAnonKey) {
  // Surface the misconfiguration loudly during dev; in production the
  // build pipeline injects these via .env.production.
  console.warn(
    '[effectiveslp] Supabase env vars missing. Set VITE_SUPABASE_URL and ' +
      'VITE_SUPABASE_ANON_KEY in .env.local.',
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    // Storage key is scoped per-app so a rebrand doesn't
    // collide with a previous install's session.
    storageKey: 'effectiveslp.auth',
  },
});
